module.exports = __webpack_public_path__ + "static/waltz_roll_mini_3-3c345be5f3243ab340a156cffe577429.jpg";